"use strict";

module.exports = {
  'name': 'dotMultiply',
  'category': 'Operators',
  'syntax': ['x .* y', 'dotMultiply(x, y)'],
  'description': 'Multiply two values element wise.',
  'examples': ['a = [1, 2, 3; 4, 5, 6]', 'b = [2, 1, 1; 3, 2, 5]', 'a .* b'],
  'seealso': ['multiply', 'divide', 'dotDivide']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/arithmetic/dotMultiply.js
// module id = 831
// module chunks = 0